import type { DatepickerInstance } from "js-datepicker";

export type DOB = {
  dob: HTMLInputElement;
  dobDay: HTMLInputElement;
  dobMonth: HTMLInputElement;
  dobYear: HTMLInputElement;
};

export function maybeDob(): NodeList {
  return document.querySelectorAll('input[name="your-birthday" i]') as NodeList;
}

export function replaceDob(dob: HTMLInputElement) {
  dob.type = "hidden";
  const template = document.querySelector(
    "#dob-template",
  )! as HTMLTemplateElement;
  const parent = dob.parentNode!;
  parent.insertBefore(template.content.cloneNode(true), dob);
  const dobDay = parent.querySelector("[data-dob-day]")! as HTMLInputElement;
  const dobMonth = parent.querySelector(
    "[data-dob-month]",
  )! as HTMLInputElement;
  const dobYear = parent.querySelector("[data-dob-year]")! as HTMLInputElement;

  return { dobDay, dobMonth, dobYear };
}

export function setupDobInteraction(
  picker: DatepickerInstance,
  { dob, dobDay, dobMonth, dobYear }: DOB,
) {
  const fields = ["dob-day", "dob-month", "dob-year"];
  const parent = dob.parentNode!.parentNode! as HTMLElement;
  const maxLengths: { [key: string]: number } = {
    "dob-day": 2,
    "dob-month": 2,
    "dob-year": 4,
  };

  fields.forEach((field, index) => {
    const input: HTMLInputElement = parent.querySelector(
      `[data-${field}]`,
    ) as HTMLInputElement;

    input.addEventListener("input", (e) => {
      if (input.value.length === maxLengths[field]) {
        const nextField = fields[index + 1];
        if (nextField) {
          const nextInput = document.getElementById(
            nextField,
          ) as HTMLInputElement;
          nextInput.focus();
          nextInput.select();
        }
      }

      const date = new Date(
        Number(dobYear.value),
        Number(dobMonth.value) - 1,
        Number(dobDay.value),
      );
      picker.setDate(date, true);
      dob!.value = `${dobYear.value}-${dobMonth.value.padStart(2, "0")}-${dobDay.value.padStart(2, "0")}`;
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Backspace" && input.value.length === 0) {
        e.preventDefault();
        const prevField = fields[index - 1];
        if (prevField) {
          const prevInput = document.getElementById(
            prevField,
          ) as HTMLInputElement;
          prevInput.focus();
          const prevValue = prevInput.value;
          prevInput.value = prevValue.slice(0, -1);
          prevInput.setSelectionRange(
            prevInput.value.length,
            prevInput.value.length,
          );
        }
      }
    });
  });
}
